import { FilterInterface } from "../@types/viewerati";


function ndrColorsOverride({ filter, background, text }: { filter: FilterInterface; background: string; text: string }): FilterInterface {
  if (!filter) return filter;

  const bkgrdModifiers = [
    "background",
    "backgroundColor",
  ];

  const textModifiers = [
    "color",
    "markerColor",
  ]

  for (const [key] of Object.entries(filter)) {
    const k = key as keyof FilterInterface;

    if (textModifiers.includes(k)) {
      // @ts-expect-error: difficult typings
      filter[k] = text
    }

    if (bkgrdModifiers.includes(k)) {
      // @ts-expect-error: difficult typings
      filter[k] = background
    }
    // recurse if it's a filter for an element
    if (filter[k] && typeof filter[k] === "object") {
      // @ts-expect-error: difficult typings
      ndrColorsOverride({ filter: filter[k], background, text });
    }
  }

  return filter;
}

export default ndrColorsOverride;
